import { useContext } from 'react';
import { SelectedElementContext } from '../contexts/SelectedElementContext';

export const useSelectedElement = () => {
  const context = useContext(SelectedElementContext);
  if (!context) {
    throw new Error('useSelectedElement must be used within a SelectedElementProvider');
  }
  return context;
};
